import { render, staticRenderFns } from "./Vendasplanospagamento.vue?vue&type=template&id=5a8d0be8&"
import script from "./Vendasplanospagamento.vue?vue&type=script&lang=js&"
export * from "./Vendasplanospagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports